import { render, staticRenderFns } from "./ClassSchedule.vue?vue&type=template&id=2100225f"
import script from "./ClassSchedule.vue?vue&type=script&lang=js"
export * from "./ClassSchedule.vue?vue&type=script&lang=js"
import style0 from "./ClassSchedule.vue?vue&type=style&index=0&id=2100225f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports